import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=79e60c0b&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=79e60c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e60c0b",
  null
  
)

export default component.exports